import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TNil } from '@app/app.interface';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';
import { IUserInvitation } from '@interfaces/user-invitation.interface';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base.component';
import { DateUtilitiesService } from '@utilities/date-utilities.service';
import { isAfter } from 'date-fns';
import { CreatorInvitationDialogComponent } from './creator-invitation-dialog/creator-invitation-dialog.component';
import { ICreatorInvitationDialogData } from './creator-invitation-dialog/creator-invitation-dialog.interface';

@Component({
  imports: [MatButtonModule, HasPermissionDirective, TranslateModule, MatTooltipModule],
  selector: 'app-creator-invitation-button',
  templateUrl: './creator-invitation-button.component.html',
})
export class CreatorInvitationButtonComponent extends BaseComponent {
  public readonly userInvitation = input.required<IUserInvitation | TNil>();
  public readonly creatorId = input.required<string>();
  public readonly creatorName = input.required<string>();

  public readonly creatorInvitation = signal<IUserInvitation | TNil>(null);
  public readonly updatedInvitation = signal<IUserInvitation | TNil>(null);

  public readonly invitationExpired = computed(() => {
    return (
      this.userInvitation()?.expire &&
      isAfter(new Date(), this.dateUtils.parseDateTimeFromApi(this.userInvitation()?.expire!))
    );
  });

  private readonly dialog = inject(MatDialog);
  private readonly dateUtils = inject(DateUtilitiesService);

  constructor() {
    super();

    effect(() => {
      this.creatorInvitation.set(this.userInvitation());
      this.updatedInvitation.set(this.userInvitation());
    });

    effect(() => {
      const updatedInvitation = this.updatedInvitation();

      if (updatedInvitation || updatedInvitation === null) {
        this.creatorInvitation.set(updatedInvitation);
      }
    });
  }

  public onInviteClick(): void {
    const data: ICreatorInvitationDialogData = {
      creatorId: this.creatorId(),
      creatorInvitation: this.creatorInvitation(),
      creatorName: this.creatorName(),
      updatedInvitation: this.updatedInvitation,
    };

    this.dialog.open(CreatorInvitationDialogComponent, {
      data,
      width: '600px',
    });
  }
}
